import * as React from 'react';
import { Link } from 'react-router-dom';

interface ITravellerDecline {
  isExisting: boolean;
}

const TravellerDecline = ({ isExisting }: ITravellerDecline) => {

  const renderPolicyLink = () => {
    return (
      <div className="return-to-account-btn mt-15">
        <Link to={`/account/summary`}>
          Return to Policies
        </Link>
      </div>
    )
  }

  if (isExisting) {
    return (
      <>
        <div className="call-center">
          <div>
            <h3 className="title">ACTION NEEDED – YOUR POLICY MAY NOT BE VALID</h3>
            <p>
              Based on the information you have provided we may be unable to continue to provide you with insurance. It
              is
              very important that you call us to discuss the change so that we can advise you on next steps. Details of
              how to contact us can be found <a target={'_blank'}
                                                href={'https://www.admiral.com/contact-us/travel'}> here </a>. <b>Please
              contact us as soon as possible</b>.

            </p>
            <p>
              If we do not hear from you within 72 hours your policy may be cancelled and you will be uninsured. It is
              important that your details are kept up to date, as incorrect information could affect your cover or any
              future claims.
            </p>
          </div>
        </div>
        {renderPolicyLink()}
      </>
    )
  }

  return (
    <>
      <div className="call-center no-center">
        <div>
          <h3 className="title" style={{ textAlign: 'center' }}>Unfortunately, we're unable to offer you Travel Insurance</h3>
          <p>Unfortunately, we are unable to add this person to your policy. This is at least partly due to the medical
            information provided.</p>
          <p>
            This means that this person is <b>not</b> covered under your insurance policy. Your cover remains unchanged,
            and
            you are still insured. If you’d like to discuss this details of how to contact us can be found <a
            target={'_blank'} href={'https://www.admiral.com/contact-us/travel'}> here </a>. It is important that your
            details are kept up to date, as incorrect information could affect your cover or any future claims.
          </p>
          <p>
            What’s next?
          </p>
          <p>
            They may be able to get cover through a specialist provider.
          </p>
          <p>
            The MoneyHelper travel insurance directory has been created for anyone who may have
            been refused Travel Insurance cover due
            to their medical conditions, to allow them to shop around for alternative providers.
          </p>
          <h4><strong>The MoneyHelper directory</strong></h4>
          <ul>
            <li>
              <a target={'_blank'}
                 href={'https://www.moneyhelper.org.uk/en/everyday-money/insurance/use-our-travel-insurance-directory'}>
                Visit their website</a> or call 0800 138 7777
            </li>
            <li>
              Opening hours: Monday to Friday 8am to 6pm
            </li>
            <li>
              <p>You can also <a target={'_blank'} href={'https://eforms.admiral.com/travel-medical-decline'}>request
                the directory details</a> in writing
              </p>
            </li>
          </ul>
          <p>
            Please bear in mind, if you insure travellers on separate policies, you may not be covered for
            claims related to the pre-existing medical conditions of someone not named on your policy.
          </p>
        </div>
      </div>
      {renderPolicyLink()}
    </>
  )
}

export default TravellerDecline;
